import { Injectable } from '@angular/core';
import {PlatformLocation} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class GuardService {

  public kreditcenter: string = undefined;

  constructor(
    private pLocation: PlatformLocation,
  ) { }

  checkKreditcenter(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let kreditcenterParam = urlParams.get('kreditcenter') ?? undefined;
    let crmTokenParam = urlParams.get('crmt') ?? undefined;


    if((this.pLocation.pathname == '/start/kreditcenter/' || kreditcenterParam) && crmTokenParam){
      this.kreditcenter = 'crmToken';
    } else if((this.pLocation.pathname == '/start/kreditcenter/' || kreditcenterParam) && !crmTokenParam) {
      this.kreditcenter = 'kreditcenterUser';
    }
    return this.kreditcenter;
  }

  checkActivityPage(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let activityPage = urlParams.get('activityToken') ?? undefined;
    if (activityPage) {
      return true;
    }
  }
}
